import { Box, Button, Fab, Tooltip } from "@mui/material";
import { createContext, useState } from "react";
import CreateReleaseJob from "./createreleasejob";
import ReleaseStatus from "./releasestatus";
import { Add, ArrowBackIosNew } from "@mui/icons-material";
import { ReleaseTable } from "../../../data/interfaces/jobmodels";
import { DropdownModel } from "../../../data/interfaces/sharedmodels";

interface ReleaseTableInfo {
    releaseTables: ReleaseTable[],
    setReleaseTables: (tables: ReleaseTable[]) => void,
    releaseFileNames:DropdownModel[],
    setReleaseFileNames:(files: DropdownModel[]) => void,
    isCreateJob:boolean,
    setIsCreateJob:(isCreate:boolean)=>void
}

export const ReleaseTableContext = createContext<ReleaseTableInfo>({isCreateJob:false,setIsCreateJob:(isCreate:boolean)=>{}, releaseTables: [], setReleaseTables: (tables: ReleaseTable[]) => { },releaseFileNames:[],setReleaseFileNames:(files: DropdownModel[]) => {} });

export default function ReleaseMain(){
    const [releaseTables, setReleaseTables] = useState<ReleaseTable[]>([]);
    const [releaseFileNames, setReleaseFileNames] = useState<DropdownModel[]>([]);
    const [isCreateJob,setIsCreateJob]=useState<boolean>(false);
    const value = { releaseTables, setReleaseTables,releaseFileNames,setReleaseFileNames,isCreateJob,setIsCreateJob };
    
    return(
        <ReleaseTableContext.Provider value={value}>
        <Box>
                {isCreateJob?
            <CreateReleaseJob/>
            :<ReleaseStatus/>

            }
        </Box>
        </ReleaseTableContext.Provider>
    )
}